import { React, useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
// import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
// import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import {
    TextField,
    FormControl,
    styled,
    Grid,
    Stack,
    Button,
    CircularProgress
} from '@mui/material';
import Cookies from 'js-cookie';
import moment from 'moment';
import { values } from 'lodash-es';
import { saveClient, getInstanceToEdit } from '../../redux/Actions/createInstance.action';
import useStyles from './styles';
// Form Components
import Environment from './form-components/Environment';
import Usages from './form-components/Usages';
import Info from './form-components/Info';
import UsageLimit from './form-components/UsageLimit';
import store from '../../redux/store';
import Notifications from '../notifications/Notifications';
import { getAllInstances } from '../../redux/Actions/instances.action';

const HeadingTextField = styled(TextField)(() => ({
    marginTop: '6px',
    input: {
        fontSize: '19px !important',
        fontWeight: 'bold',
        paddingTop: '12px',
        textOverflow: 'ellipsis'
    }
}));

export default function Create({ match, history }) {
    const dispatch = useDispatch();
    const [isSubmitingForm, setIsSubmitingForm] = useState(false);
    let isEditable = false;
    let tenantid = null;
    const instanceData = useSelector((state) => state.instance.allClients);
    const datvalue = useSelector((state) => state.createInstanceReducer);
    if (match.params.tenantid) {
        isEditable = true;
        tenantid = match.params.tenantid;
    }

    const classes = useStyles();
    const [val, setVal] = useState({});
    const [initialValues, setInitialValues] = useState({
        heading: ''
    });
    const handleChange = (val) => (e) => {
        setInitialValues({
            ...initialValues,
            [val]: e.target.value
        });
    };
    const negativeData = (data) => {
        console.log(data);
        let check = false;
        if (
            data.usageDetails.adminLicenseLimit === '' ||
            data.usageDetails.adminLicenseLimit < 0 ||
            data.usageDetails.contentSourceLimit < 0 ||
            data.usageDetails.contentSourceLimit === '' ||
            data.usageDetails.indexSizeLimit < 0 ||
            data.usageDetails.indexSizeLimit === '' ||
            data.usageDetails.documentsLimit < 0 ||
            data.usageDetails.documentsLimit === '' ||
            data.usageDetails.searchesLimit < 0 ||
            data.usageDetails.searchesLimit === '' ||
            data.usageDetails.searchClientsLimit < 0 ||
            data.usageDetails.searchClientsLimit === ''
        ) {
            check = true;
        }
        Object.keys(data.usageLimit).map((value) => {
            if (
                data.usageLimit[value].minute < 0 ||
                data.usageLimit[value].minute === '' ||
                data.usageLimit[value].hourly < 0 ||
                data.usageLimit[value].hourly === '' ||
                data.usageLimit[value].monthly === '' ||
                data.usageLimit[value].monthly < 0 ||
                data.usageLimit[value] < 0 ||
                data.usageLimit[value] === ''
            ) {
                check = true;
            }
            return check;
        });
        return check;
    };
    const [isTenantInvalid, setIsTenantInvalid] = useState(false);
    const [isFormInvalid, setIsFormInvalid] = useState(false);
    const [invalidDateError, setInvalidDateError] = useState(false);
    const [invalidDateErrorEnd, setInvalidDateErrorEnd] = useState(false);
    const [dateRangeError, setDateRangeError] = useState(false);
    const [isServerUrlError, setIsServerUrlError] = useState(false);
    const tenantIdRef = useRef();
    const serverUrlRef = useRef();
    const validate = (values, data) => {
        let check = false;
        if (!data.environemtDetails.prodLink.length) {
            setIsServerUrlError(true);
            check = true;
            window.scrollTo(0, serverUrlRef.current.offsetTop);
        }
        if (data.info.tenantId === '') {
            setIsTenantInvalid(true);
            check = true;
            window.scrollTo(0, tenantIdRef.current.offsetTop);
        }
        if (values.heading === '') {
            setIsFormInvalid(true);
            check = true;
            window.scrollTo(0, 0);
        }
        if (!moment(data.info.startDate).isValid()) {
            setInvalidDateError(true);
            check = true;
            window.scrollTo(0, 0);
        }
        if (!moment(data.info.endDate).isValid()) {
            setInvalidDateErrorEnd(true);
            check = true;
            window.scrollTo(0, 0);
        }
        if (moment(data.info.startDate) > moment(data.info.endDate)) {
            setDateRangeError(true);
            check = true;
            window.scrollTo(0, 0);
        }
        return check;
    };
    useEffect(() => {
        async function fetchData() {
            const editTableClientInfo = await getInstanceToEdit(tenantid);
            setVal(editTableClientInfo);
            if (editTableClientInfo.licenseType) {
                setInitialValues({
                    heading: editTableClientInfo.name
                });
            }
        }
        if (tenantid) {
            fetchData();
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const valuesToSave = store.getState().createInstanceReducer;
        if (!validate(initialValues, valuesToSave)) {
            setIsSubmitingForm(true);
            let tenantIdExist = false;
            let namesExist = false;
            let formError = false;
            if (!isEditable) {
                if (instanceData[0] && instanceData[0].clients) {
                    const s = instanceData[0].clients.find(
                        (iD) => iD.tenantId === valuesToSave.info.tenantId
                    );
                    if (s) {
                        tenantIdExist = true;
                        formError = true;
                    }
                    const t = instanceData[0].clients.find(
                        (iD) => iD.name.toLowerCase() === initialValues.heading.toLowerCase()
                    );
                    if (t) {
                        namesExist = true;
                        formError = true;
                    }
                }
            }
            if (!formError) {
                const allValues = {
                    licenseType: valuesToSave.info.type,
                    tenantId: valuesToSave.info.tenantId,
                    releaseVersion: valuesToSave.info.version,
                    annualSupportPackage: valuesToSave.info.annpackage,
                    subscriptionStartDate: valuesToSave.info.startDate,
                    subscriptionEndDate: valuesToSave.info.endDate,
                    status: valuesToSave.info.accStatus,
                    dataCenter: valuesToSave.info.location,
                    usages: {
                        searchApiLimit: {
                            monthly:
                                valuesToSave.usageLimit.searchApiLimit.monthly > 0
                                    ? valuesToSave.usageLimit.searchApiLimit.monthly
                                    : 0,
                            hourly:
                                valuesToSave.usageLimit.searchApiLimit.hourly > 0
                                    ? valuesToSave.usageLimit.searchApiLimit.hourly
                                    : 0,
                            minute:
                                valuesToSave.usageLimit.searchApiLimit.minute > 0
                                    ? valuesToSave.usageLimit.searchApiLimit.minute
                                    : 0
                        },
                        analyticsApiLimit: {
                            minute:
                                valuesToSave.usageLimit.analyticsApiLimit.minute > 0
                                    ? valuesToSave.usageLimit.analyticsApiLimit.minute
                                    : 0,
                            hourly:
                                valuesToSave.usageLimit.analyticsApiLimit.hourly > 0
                                    ? valuesToSave.usageLimit.analyticsApiLimit.hourly
                                    : 0,
                            monthly:
                                valuesToSave.usageLimit.analyticsApiLimit.monthly > 0
                                    ? valuesToSave.usageLimit.analyticsApiLimit.monthly
                                    : 0
                        },
                        contentApiLimit: {
                            minute:
                                valuesToSave.usageLimit.contentApiLimit.minute > 0
                                    ? valuesToSave.usageLimit.contentApiLimit.minute
                                    : 0,
                            hourly:
                                valuesToSave.usageLimit.contentApiLimit.hourly > 0
                                    ? valuesToSave.usageLimit.contentApiLimit.hourly
                                    : 0,
                            monthly:
                                valuesToSave.usageLimit.contentApiLimit.monthly > 0
                                    ? valuesToSave.usageLimit.contentApiLimit.monthly
                                    : 0
                        },
                        chatbotApiLimit: {
                            minute:
                                valuesToSave.usageLimit.chatbotApiLimit.minute > 0
                                    ? valuesToSave.usageLimit.chatbotApiLimit.minute
                                    : 0,
                            hourly:
                                valuesToSave.usageLimit.chatbotApiLimit.hourly > 0
                                    ? valuesToSave.usageLimit.chatbotApiLimit.hourly
                                    : 0,
                            monthly:
                                valuesToSave.usageLimit.chatbotApiLimit.monthly > 0
                                    ? valuesToSave.usageLimit.chatbotApiLimit.monthly
                                    : 0
                        },
                        adminLicenseLimit:
                            valuesToSave.usageDetails.adminLicenseLimit > 0
                                ? valuesToSave.usageDetails.adminLicenseLimit
                                : 0,
                        kcsLicenseLimit:
                            valuesToSave.usageDetails.kcsLicenseLimit > 0
                                ? valuesToSave.usageDetails.kcsLicenseLimit
                                : 0,
                        chatbotLicenseLimit:
                            valuesToSave.usageDetails.chatbotLicenseLimit > 0
                                ? valuesToSave.usageDetails.chatbotLicenseLimit
                                : 0,
                        contentSourceLimit:
                            valuesToSave.usageDetails.contentSourceLimit > 0
                                ? valuesToSave.usageDetails.contentSourceLimit
                                : 0,
                        indexSizeLimit:
                            valuesToSave.usageDetails.indexSizeLimit > 0
                                ? valuesToSave.usageDetails.indexSizeLimit
                                : 0,
                        documentsLimit:
                            valuesToSave.usageDetails.documentsLimit > 0
                                ? valuesToSave.usageDetails.documentsLimit
                                : 0,
                        searchClientsLimit:
                            valuesToSave.usageDetails.searchClientsLimit > 0
                                ? valuesToSave.usageDetails.searchClientsLimit
                                : 0,
                        searchesLimit:
                            valuesToSave.usageDetails.searchesLimit > 0
                                ? valuesToSave.usageDetails.searchesLimit
                                : 0,
                        apiUsagePerSecond:
                            valuesToSave.usageLimit.apiUsagePerSecond > 0
                                ? valuesToSave.usageLimit.apiUsagePerSecond
                                : 0
                    },
                    name: initialValues.heading,
                    hostname: valuesToSave.info.hostname,
                    instances: {
                        sandbox: valuesToSave.environemtDetails.fields,
                        production: valuesToSave.environemtDetails.prodLink,
                        statusPage: valuesToSave.environemtDetails.serviceLink,
                        type: valuesToSave.environemtDetails.type
                    },
                    updatedBy: Cookies.get('name') || '',
                    isDeleted: false,
                    services: valuesToSave.info.services || [],
                    harborRepo: valuesToSave.info.harborRepo || '',
                    newReleaseVersion: val.newReleaseVersion || ''
                };

                if (!val.updatedBy) {
                    allValues.createdBy = Cookies.get('name') || '';
                }

                try {
                    await saveClient(allValues, history);
                    if (isEditable) {
                        toast.success('Instance updated successfully');
                    } else {
                        toast.success('Instance added successfully');
                    }
                    dispatch(getAllInstances({}));
                    setTimeout(() => {
                        setIsSubmitingForm(false);
                        history.push('/instances/list');
                    }, 850);
                } catch (err) {
                    if (isEditable) {
                        toast.error('Error while updating');
                    } else {
                        toast.error('Error while adding instance');
                    }
                    setIsSubmitingForm(false);
                }
            } else {
                if (tenantIdExist) {
                    toast.error('Tenant id already exists');
                } else if (namesExist) {
                    toast.error('Name already exists');
                }
                setIsSubmitingForm(false);
            }
        }
    };
    return (
        <div key="fromCheck1">
            <Notifications />
            <form onSubmit={handleSubmit} key="fromCheck1" className={classes.respForm}>
                <div className={classes.mainHeadForm}>
                    <Grid container>
                        <Grid item xs={4}>
                            <div>
                                <FormControl
                                    fullWidth
                                    sx={{ m: 1 }}
                                    style={{ textOverflow: 'ellipsis' }}
                                >
                                    <HeadingTextField
                                        type="text"
                                        // title="Name Of Instance"
                                        // disabled={disable}
                                        onFocus={() => setIsFormInvalid(false)}
                                        error={isFormInvalid}
                                        helperText={isFormInvalid && 'Required field'}
                                        variant="standard"
                                        placeholder="Name of Instance*"
                                        value={initialValues.heading}
                                        onChange={handleChange('heading')}
                                        InputProps={{ disableUnderline: true }}
                                    />
                                </FormControl>
                                {/* <ModeEditOutlineOutlinedIcon
                            onClick={handleClick}
                            style={{
                                marginTop: '30px',
                                cursor: 'pointer',
                                fontSize: 'large'
                            }}
                        /> */}
                            </div>
                        </Grid>
                        <Grid item xs={8}>
                            <div className={classes.headContainer}>
                                <Stack spacing={3} direction="row">
                                    <Button
                                        onClick={() => {
                                            history.push('/instances/list');
                                        }}
                                        disabled={isSubmitingForm}
                                        size="medium"
                                        variant="outlined"
                                        style={{ minWidth: '90px' }}
                                    >
                                        Cancel
                                    </Button>
                                    {isEditable ? (
                                        <Button
                                            disabled={isSubmitingForm || negativeData(datvalue)}
                                            size="large"
                                            variant="outlined"
                                            type="submit"
                                            style={{ minWidth: '96px' }}
                                        >
                                            {!isSubmitingForm ? (
                                                'Update'
                                            ) : (
                                                <CircularProgress size={16} />
                                            )}
                                        </Button>
                                    ) : (
                                        <Button
                                            disabled={isSubmitingForm || negativeData(datvalue)}
                                            size="large"
                                            variant="outlined"
                                            type="submit"
                                            style={{ minWidth: '96px' }}
                                        >
                                            {!isSubmitingForm ? (
                                                'Add'
                                            ) : (
                                                <CircularProgress size={16} />
                                            )}
                                        </Button>
                                    )}
                                </Stack>
                            </div>
                        </Grid>
                    </Grid>
                </div>

                <Info
                    val={val}
                    isEditable={isEditable}
                    isTenantInvalid={isTenantInvalid}
                    setIsTenantInvalid={setIsTenantInvalid}
                    invalidDateError={invalidDateError}
                    setInvalidDateError={setInvalidDateError}
                    dateRangeError={dateRangeError}
                    setDateRangeError={setDateRangeError}
                    setInvalidDateErrorEnd={setInvalidDateErrorEnd}
                    invalidDateErrorEnd={invalidDateErrorEnd}
                    tenantIdRef={tenantIdRef}
                />

                <Environment
                    val={val}
                    setIsServerUrlError={setIsServerUrlError}
                    isServerUrlError={isServerUrlError}
                    serverUrlRef={serverUrlRef}
                />
                <UsageLimit isEditable={isEditable} val={val} />
                <Usages val={val} />
            </form>
        </div>
    );
}
